module.exports = __webpack_public_path__ + "img/img4.272eb65e.png";